<template>
    <div
        class="block-showcase-tile"
    >
        <template
            v-if="modelValue.videoHosted"
        >
            <VideoDialog
                :video-id="modelValue.videoHosted.id"
            >
                <template #default="{ props: slotProps }">
                    <v-card
                        elevation="2"
                        class="card-play-video"
                        v-bind="slotProps"
                        role="button"
                        :aria-label="modelValue.heading"
                    >
                        <FullImage
                            :image-object="tileImage"
                            :type="isMobile ? 'medium' : 'large'"
                            tag="VImg"
                            :aspect-ratio="aspectRatio"
                            :position="imagePosition"
                            :cover="imageFit === 'cover'"
                            disable-drop-shadow
                        />
                        <v-icon
                            class="card-play-video-icon"
                            size="80"
                            :icon="mdiPlayCircle"
                        ></v-icon>
                    </v-card>
                    <div
                        class="d-block text-center text-uppercase font-size-7 letter-spacing-5 font-weight-medium mt-4"
                    >
                        {{ modelValue.heading }}
                    </div>
                </template>
            </VideoDialog>
        </template>
        <template
            v-else
        >
            <v-card
                :to="modelValue.link"
                elevation="2"
                :aria-label="modelValue.heading"
            >
                <FullImage
                    :image-object="tileImage"
                    :type="isMobile ? 'medium' : 'large'"
                    tag="VImg"
                    :aspect-ratio="aspectRatio"
                    :position="imagePosition"
                    :cover="imageFit === 'cover'"
                    :disable-drop-shadow="imageDisableDropShadowOverride"
                />
            </v-card>
            <NuxtLink
                :to="modelValue.link"
                class="no-style-link d-block text-center text-uppercase font-size-6 letter-spacing-5 font-weight-bold mt-4"
                :aria-label="modelValue.heading"
            >
                {{ modelValue.heading }}
            </NuxtLink>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import type {
        FullImage as FullImageType,
        ShowcaseTileStandardV1
    } from '~/types';
    import { mdiPlayCircle } from '@mdi/js';

    const props = withDefaults(
        defineProps<{
            modelValue: ShowcaseTileStandardV1['values'];
            isMobile: boolean;
            breakpoint: string;
            breakpointName: string;
            aspectRatio?: number;
        }>(),
        {
            aspectRatio: 322 / 212
        }
    );

    const FullImage = defineAsyncComponent(() => import('~/components/media/FullImage/FullImage.vue'));
    const VideoDialog = defineAsyncComponent(() => import('~/components/video/VideoDialog/VideoDialog.vue'));

    const tileImage = computed<FullImageType>(() =>
        props.isMobile && props.modelValue.altImage
            ? props.modelValue.altImage
            : props.modelValue.image
    );

    const imagePosition = computed<Undefinable<string>>(() => props.isMobile && props.modelValue.altImage ? props.modelValue.altImagePosition : props.modelValue.imagePosition);
    const imageFit = computed<Undefinable<string>>(() => props.isMobile && props.modelValue.altImage ? props.modelValue.altImageFit : props.modelValue.imageFit);
    const imageDisableDropShadowOverride = computed<boolean>(() => props.isMobile && props.modelValue.altImage ? props.modelValue.altImageDisableDropShadowOverride : props.modelValue.imageDisableDropShadowOverride);
</script>

<style lang="scss">
.block-showcase-tile {
    .card-play-video {
        position: relative;

        &-icon {
            position: absolute !important;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            filter: invert(1);
        }
    }
}
</style>
